<script context="module"></script>

<script>import InlinedStyles from "../../inlined-styles.svelte";
import { getCss, getDefaultStyles, getFontCss } from "./styles.helpers";
export let cssCode = undefined;
export let contentId = undefined;
export let customFonts = undefined;
export let isNestedRender = undefined;
export let nonce;
let injectedStyles = `
${getCss({
    cssCode: cssCode,
    contentId: contentId,
})}
${getFontCss({
    customFonts: customFonts,
})}
${getDefaultStyles(isNestedRender)}
`.trim();
</script>

<InlinedStyles id="builderio-content" styles={injectedStyles} {nonce} />